import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { URL_API } from "../config/config";
import { Vehiculo } from '../models/vehiculos.model';

@Injectable({
  providedIn: 'root'
})
export class VehiculosService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' })
  };

  constructor(private http: HttpClient) { }

  get_listar(page: string, limit: string) {
    const url = URL_API + '/vehiculos/get_listar/' + page + '/' + limit;
    return this.http.get(url);
  }

  get_listar_clientes_vehiculos(page: string, limit: string) {
    const url = URL_API + '/vehiculos/get_listar_clientes_vehiculos/' + page + '/' + limit;
    return this.http.get(url);
  }

  get_buscar(pagina: string, limit: string, buscar: string) {
    const url = URL_API + '/vehiculos/get_buscar/' + pagina + '/' + limit + '/' + buscar;
    return this.http.get(url);
  }

  get_buscar_clientes_vehiculos(pagina: string, limit: string, buscar: string) {
    const url = URL_API + '/vehiculos/get_buscar_clientes_vehiculos/' + pagina + '/' + limit + '/' + buscar;
    return this.http.get(url);
  }

  create(model: any) {
    const url = URL_API + '/vehiculos/nuevo';
    return this.http.post(url, model, this.httpOptions);
  }

  getbyid(id: string) {
    const url = URL_API + '/vehiculos/get_byid/' + id;
    return this.http.get(url);
  }

  update(id: string, model: Vehiculo) {
    const url = URL_API + '/vehiculos/update/' + id;
    return this.http.put(url, model, this.httpOptions);
  }

  getdelete (id: string)  {
    const url = URL_API + '/vehiculos/delete/' + id;
    return this.http.delete(url, this.httpOptions);
  }
}
